import { createContext, useContext } from "react";
import { ProductCatalogClient, CCPProductCatalogClient } from "@atlassiansox/asc-product-catalog";
import { ProductPricingStore } from "@atlassiansox/bxp-product-pricing";

const productCatalogClient = new ProductCatalogClient({
  space: LOCALIZED_PRICING_CONTENTFUL_SPACE,
  environment: LOCALIZED_PRICING_CONTENTFUL_ENVIRONMENT,
  accessToken: LOCALIZED_PRICING_CONTENTFUL_ACCESS_TOKEN,
});

const ccpProductCatalogClient = new CCPProductCatalogClient({
  space: LOCALIZED_PRICING_CONTENTFUL_SPACE,
  environment: LOCALIZED_CCP_PRICING_CONTENTFUL_ENVIRONMENT,
  accessToken: LOCALIZED_CCP_PRICING_CONTENTFUL_ACCESS_TOKEN,
});

const pricingStore = new ProductPricingStore({ productCatalogClient,ccpProductCatalogClient });

export const BundleContext = createContext({
  productCatalogClient,
  pricingStore
});

export function useBundleContext() {
  return useContext(BundleContext);
}
